// This is just an example,
// so you can safely delete all default props below

export default {
  failed: 'Action failed',
  success: 'Action was successful',
  actions: {
    save: 'Save',
    cancel: 'Cancel',
    update: 'Update'
  },
  settings: {
    label: 'Settings',
    details: 'Details',
    users: 'Users'
  },
  asset: {
    details: 'Details',
    create: 'New Profile',
    edit: 'Edit Profile',
    namePlural: 'Profiles',
    name: 'Profile',
    teamPlural: 'Profiles'
  },
  team: {
    dashboard: 'Dashboard',
    details: 'Details',
    create: 'New Customer',
    edit: 'Edit Customer',
    namePlural: 'Customers',
    name: 'Customer',
    userPlural: 'Members',
    current: 'Current Customer'
  },
  document: {
    name: 'Document',
    namePlural: 'Documents'
  },
  job: {
    name: 'Job',
    namePlural: 'Jobs'
  },
  photo: {
    name: 'Photo',
    namePlural: 'Photos'
  },
  medicalProvider: {
    name: 'Provider',
    namePlural: 'Providers'
  },
  address: {
    line1: 'Unit, Level, Building Name',
    line2: 'Street Number & Name',
    suburb: 'Suburb',
    state: 'State',
    postcode: 'Postcode'
  }
};